import {DomainObject} from 'shared/store';
import {t} from 'shared/core';
import { observable, computed, makeObservable } from 'mobx';
import Position from './Position';
import Location from '../locations/Location';

class InvalidIndeedLocation extends DomainObject {
  location;
  positions;
  missingFields;

  _relations = {
    location: Location,
    positions: [Position]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      location: observable,
      positions: observable,
      missingFields: observable,
      missingFieldsView: computed
    });

    this.merge(other);
  }

  get missingFieldsView() {
    return this.missingFields.map((field) => t(`recruiting.job_site.invalid_locations.missing_fields.${field}`)).join(', ');
  }
}

export default InvalidIndeedLocation;
